import { videoPath } from './videos'

export const convertImgLink = (link: string, basepath: string) => {
  if (!link || !basepath) return ''
  const splitedString = link.split('/')
  const vidName = splitedString[splitedString?.length - 1] || ''
  return videoPath(vidName?.split('.')[0]?.split('_')[0] + '.mp4', basepath)
}
